import SurveyResponsesMonthlyReportCard from './SurveyResponsesMonthlyReportCard';

export default SurveyResponsesMonthlyReportCard;
